module.exports = __webpack_public_path__ + "media/crypto/uni-f2126aa5.png";